import { auth } from "~/plugins/firebase"

export const signupEmail = (email: string, password: string) => {
  return auth.createUserWithEmailAndPassword(email, password)
}
